// extracted by mini-css-extract-plugin
module.exports = {"dialog":"Dialog_dialog__fJBvA","close":"Dialog_close__EIoUb","highlight":"Dialog_highlight__Uu4xj"};